var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-nav" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.axiosFinished,
              expression: "!axiosFinished",
            },
          ],
          staticClass: "log",
        },
        [
          !_vm.logoUrl && _vm.axiosFinished
            ? _c("svg-icon", {
                attrs: {
                  "icon-class": "DataEase",
                  "custom-class": "top-nav-logo-icon",
                },
              })
            : _vm._e(),
          _vm.logoUrl && _vm.axiosFinished
            ? _c("img", {
                staticStyle: { "padding-top": "10px" },
                attrs: { src: _vm.logoUrl, width: "140", alt: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-menu",
        {
          staticClass: "de-top-menu",
          style: { "margin-left": "260px", position: "absolute" },
          attrs: {
            mode: "horizontal",
            "active-text-color": "#FFFFFF",
            "default-active": _vm.activeMenu,
          },
          on: { select: _vm.handleSelect },
        },
        _vm._l(_vm.permission_routes, function (item) {
          return _c(
            "div",
            { key: item.path, staticClass: "nav-item" },
            [
              _c(
                "app-link",
                { attrs: { to: _vm.resolvePath(item) } },
                [
                  !item.hidden
                    ? _c("el-menu-item", { attrs: { index: item.path } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.meta
                                ? item.meta.title
                                : item.children[0].meta.title
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "right-menu",
          staticStyle: { color: "var(--TopTextColor)" },
        },
        [
          _c("notification", { staticClass: "right-menu-item hover-effect" }),
          _c("lang-select", { staticClass: "right-menu-item hover-effect" }),
          _c(
            "div",
            {
              staticClass: "right-menu-item hover-effect",
              staticStyle: { height: "100%", padding: "0 8px" },
            },
            [
              _c(
                "a",
                {
                  staticStyle: {
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    "justify-content": "center",
                    "align-items": "center",
                  },
                  attrs: { href: _vm.helpLink, target: "_blank" },
                },
                [_c("svg-icon", { attrs: { "icon-class": "docs" } })],
                1
              ),
            ]
          ),
          _c(
            "el-dropdown",
            {
              ref: "my-drop",
              staticClass: "top-dropdown",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                width: "100px",
              },
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-dropdown-link",
                  staticStyle: {
                    display: "flex",
                    color: "var(--TopTextColor)",
                    "font-size": "14px",
                    width: "100%",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "max-width": "80px",
                        "white-space": "nowrap",
                        "text-overflow": "ellipsis",
                        overflow: "hidden",
                      },
                    },
                    [_vm._v(_vm._s(_vm.name))]
                  ),
                  _c("span", [
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                ]
              ),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/person-info/index" } },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(_vm._s(_vm.$t("commons.personal_info"))),
                      ]),
                    ],
                    1
                  ),
                  _vm.$store.getters.validate
                    ? _c(
                        "router-link",
                        { attrs: { to: "/ukey/index" } },
                        [
                          _c("el-dropdown-item", [
                            _vm._v(_vm._s(_vm.$t("commons.ukey_title"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isOtherPlatform
                    ? _c(
                        "router-link",
                        { attrs: { to: "/person-pwd/index" } },
                        [
                          _c("el-dropdown-item", [
                            _vm._v(_vm._s(_vm.$t("user.change_password"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "router-link",
                    { attrs: { to: "/about/index" } },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(_vm._s(_vm.$t("commons.about_us"))),
                      ]),
                    ],
                    1
                  ),
                  !_vm.isOtherPlatform
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.logout($event)
                            },
                          },
                        },
                        [
                          _c("span", { staticStyle: { display: "block" } }, [
                            _vm._v(_vm._s(_vm.$t("commons.exit_system"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.templateMarketShow,
            "show-close": false,
            fullscreen: true,
            "append-to-body": "",
          },
        },
        [
          _vm.templateMarketShow
            ? _c("template-market", {
                staticStyle: { "text-align": "center" },
                on: {
                  closeDialog: function ($event) {
                    return _vm.changeTemplateMarketShow(false)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }